import type { UserProfile } from './userProfile';
import { normalizeDisplayName } from './userProfile';

export type ProfileGateView =
  | 'loading'
  | 'error'
  | 'onboarding'
  | 'application';

export function resolveProfileGate({
  profile,
  loading,
  loadError,
}: {
  profile: UserProfile | null;
  loading: boolean;
  loadError: string | null;
}): ProfileGateView {
  if (loading) return 'loading';
  if (loadError) return 'error';
  return profile ? 'application' : 'onboarding';
}

export function canSubmitProfileName(
  displayName: string,
  submitting: boolean,
): boolean {
  if (submitting) return false;
  try {
    normalizeDisplayName(displayName);
    return true;
  } catch {
    return false;
  }
}

export function createProfileFromSubmission(
  displayName: string,
  submitting: boolean,
  createProfile: (value: string) => UserProfile,
): UserProfile | null {
  if (!canSubmitProfileName(displayName, submitting)) return null;
  return createProfile(displayName);
}

export function updateProfileFromSubmission(
  displayName: string,
  updateDisplayName: (value: string) => UserProfile,
): UserProfile {
  normalizeDisplayName(displayName);
  return updateDisplayName(displayName);
}
